import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';

export const UnclaimedEarningsTooltipContent = () => {
  return (
    <ul className={css({ list: 'disc' })}>
      <li>
        <FormattedMessage id='Earn.r260212.Unclaimed_earnings_description_1' />
      </li>
      <li>
        <FormattedMessage id='Earn.r260212.Unclaimed_earnings_description_2' />
      </li>
      <li>
        <FormattedMessage id='Earn.r260212.Unclaimed_earnings_description_3' />
      </li>
      <li>
        <FormattedMessage id='Earn.r260212.Unclaimed_earnings_description_4' />
      </li>
    </ul>
  );
};
